import React from "react";
import { Link } from "react-router-dom";
import { TrendingUp, Users, Award, Target, Sparkles, ArrowUpRightSquare } from "lucide-react";

export default function PartnerRewards() {
  const items = [
    { icon: TrendingUp, title: "Retail Profit", body: "Buy products at partner wholesale price and sell at retail. Keep the margin on every unit sold — 10% for Starter, 18% for Builder, 25% for Executive tier." },
    { icon: Users, title: "Direct Referral Bonus", body: "Earn a flat percentage of the qualifying Business Starter Kit purchase (illustrative: 10%) whenever you enroll a new partner." },
    { icon: Award, title: "Team Sales Overrides", body: "Illustrative levels: 5% Level 1 · 3% Level 2 · 2% Level 3 · 1% Level 4 · 1% Level 5. Every override is funded exclusively by real product transactions in your team." },
    { icon: Target, title: "Monthly Incentives", body: "Hit performance milestones to unlock leadership bonuses, community recognition, and priority payout perks." },
  ];
  const principles = [
    "Commissions are funded from product sales — not from membership fees alone",
    "Team rewards depend on qualifying product transactions and ongoing retail activity",
    "Qualification rules encourage genuine retail commerce (e.g., active status via personal sales volume)",
    "Earnings vary based on actual sales performance and are not guaranteed",
  ];

  return (
    <div className="space-y-10" data-testid="partner-rewards-page">
      <div>
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.28em] text-[#FBBF24] font-bold mb-3">
          <Sparkles size={12} /> Partner Rewards Program
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight max-w-3xl">
          Earn by helping others{" "}
          <span className="text-[#FBBF24]">build their business.</span>
        </h1>
        <p className="text-white/70 max-w-3xl mt-5 leading-relaxed">
          Every commission stream on Zenith Flow Dynamics is funded by real product sales, not membership fees.
          Qualification rules keep incentives aligned with genuine retail commerce &mdash; the healthier your team&apos;s
          product volume, the healthier your earnings.
        </p>
      </div>

      <div className="grid gap-5 md:grid-cols-2">
        {items.map((r) => (
          <div key={r.title} className="glass-card p-6" data-testid={`rewards-detail-${r.title.toLowerCase().replace(/\s+/g, "-")}`}>
            <r.icon size={24} className="text-[#FBBF24]" />
            <div className="mt-3 font-display text-xl font-black">{r.title}</div>
            <p className="mt-2 text-sm text-white/70 leading-relaxed">{r.body}</p>
          </div>
        ))}
      </div>

      <div className="glass-card gold-border p-6 md:p-8">
        <div className="text-[10px] uppercase tracking-[0.22em] text-[#FBBF24] font-bold mb-3">Program Principles</div>
        <ul className="space-y-3">
          {principles.map((p) => (
            <li key={p} className="flex items-start gap-3 text-sm md:text-base text-white/80">
              <span className="w-1.5 h-1.5 rounded-full bg-[#FBBF24] mt-2 shrink-0" /> {p}
            </li>
          ))}
        </ul>
      </div>

      <div className="text-center pt-4">
        <Link to="/simulator" className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-bold uppercase tracking-widest border border-white/20 hover:border-[#FBBF24] hover:text-[#FBBF24]" data-testid="rewards-simulator-cta">
          <ArrowUpRightSquare size={14} /> Try the Business Income Simulator
        </Link>
      </div>
    </div>
  );
}
